var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-config"},[_c('el-switch',{attrs:{"inactive-text":"加我为好友时需要验证"},on:{"change":_vm.onManualApproveChange},model:{value:(_vm.userInfo.isManualApprove),callback:function ($$v) {_vm.$set(_vm.userInfo, "isManualApprove", $$v)},expression:"userInfo.isManualApprove"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }